import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/401k-calculator',
  component: () => import('../../routes/Route401k.svelte'),
  card: {
    id: '401k-calculator',
    title: '401(k) Calculator',
    description: 'Estimate your 401(k) balance at retirement including employer match and investment growth. See projected monthly retirement income using the 4% rule.',
    icon: 'account_balance',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-primary',
    href: '/401k-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: '401(k) Calculator – 401k Balance & Retirement Income Calculator',
    description: 'Free 401k calculator to estimate your retirement balance with employer match, contribution projections, and monthly retirement income using the 4% safe withdrawal rule. Year-by-year growth breakdown included.',
  },
};

export default meta;
